import { render } from "./mass-edit.vue?vue&type=template&id=618db9c4&ts=true"
import script from "./mass-edit.ts?vue&type=script&lang=ts&external"
export * from "./mass-edit.ts?vue&type=script&lang=ts&external"

import "./mass-edit.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__